import React, { useState } from "react"
import { css } from "@emotion/core"
import { colors } from "css/theme"
import { trackEvent } from "src/util"
import useHubspotForm from "src/hooks/use-hubspot-form"
import formCSS from "css/hubspot-form-light"
import { util } from "prettier"
import { If } from "src/components"

const text = css`
  color: black;
  a {
    color: ${colors.orange};
  }
`

const wrapper = [
  formCSS,
  `
  background-color: white;
  padding: 1.5rem 1.5rem 0.5rem;
  border-radius: 8px;
`,
]

function FormWrapper({ resourceLink }) {
  const [hasSubmitted, setSubmitted] = useState(false)
  const { error } = useHubspotForm({
    formId: "03a2fe18-92e4-4ac2-93d1-3a2618355f4e",
    target: "#resource-form",
    onFormSubmitted: () => {
      trackEvent("ANY_FORM_SUBMISSION", "Submit")
      if (resourceLink) {
        window.location.href = resourceLink
      } else {
        util.logError("Resource pdf link, not found")
      }
      setSubmitted(true)
    },
  })
  return (
    <div css={wrapper}>
      <div id="resource-form" className="hs-form-wrapper">
        {error ? "Could not load form" : null}
      </div>
      <If test={hasSubmitted && resourceLink}>
        <p css={text}>
          In case your download didn't begin,{" "}
          <a href={resourceLink}>click here to download</a>
        </p>
      </If>
    </div>
  )
}

export default FormWrapper
